import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import ExhibitorService from "../services";
import { SortField } from "../../../utils/schema/SortType";
import qs from "qs";

interface UseExhibitorsParams {
  rowsPerPage?: number;
  sortFields?: SortField[];
  searchExhibitor?: string;
  // enabled?: boolean;
}

export const useInfiniteExhibitors = ({
  rowsPerPage,
  sortFields,
  searchExhibitor,
  // enabled = true,
}: UseExhibitorsParams = {}) => {

  const sortParam = sortFields
    ? sortFields.map(({ field, order }) => `${field}:${order}`)
    : undefined;

    const fetchExhibitors = async ({ pageParam = 1 }) => {
        const query = qs.stringify(
          {
            sort: sortParam,
            pagination: { page: pageParam, pageSize: rowsPerPage },
            filters: searchExhibitor ? { name: { $contains: searchExhibitor } } : {},
            populate: "*",
          },
        );
        return ExhibitorService.getAll({query})
      };
  return useInfiniteQuery({
    queryKey: ["exhibitors", rowsPerPage, searchExhibitor],
    queryFn: fetchExhibitors,
    getNextPageParam: (lastPage) => {
        const { page, pageCount } = lastPage.pagination;
        return page < pageCount ? page + 1 : undefined;
      },
      initialPageParam: 1,
      // enabled, 
  });
};
